import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ArrowRight from "@material-ui/icons/KeyboardArrowRight";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import SearchOutlined from "@material-ui/icons/SearchOutlined";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import RadioGroup from "@material-ui/core/RadioGroup";
import Menu from "@material-ui/core/Menu";

const styles = theme => ({
  terminalMenuRoot: {
    zIndex: 1400
  },
  root: {
    maxWidth: 150,
    maxHeight: 400,
    overflow: "hidden",
    backgroundColor: theme.ModalBGColor,
    padding: "17px"
  },
  radioLabel: {
    height: "12px"
  },
  label: {
    color: theme.gridTextColor,
    fontWeight: 600,
    fontSize: theme.textFontSize
  },
  radioRoot: {
    width: "20px",
    color: theme.HeaderSelectedText
  },
  textField: {
    width: 115
  },
  searchBar: {
    borderBottom: `1px solid ${theme.iconColor}`,
    padding: "0px 8px"
  },
  list: {
    paddingTop: "10px"
  },
  listroot: {
    overflowY: "auto",
    maxHeight: 250,
  },
  inputroot: {
    color: theme.gridTextColor,
    fontSize: theme.textFontSize
  },
  noOptions: {
    padding: "18px",
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize
  },
  disbalePadding: {
    padding: "0px"
  },
  enablePadding: {
    paddingLeft: "25px"
  },
  terminalClicked: {
    paddingTop: "6px",
    paddingBottom: "7px",
    "&:hover": {
      backgroundColor: theme.ModalBGColor
    },
    "&:focus": {
      backgroundColor: theme.ModalBGColor
    }
  },
  terminalMenu: {
    background: theme.ModalBGColor,
    borderRadius: "0px 0px 4px 4px",
    marginTop: "10px"
  },
  collapseIconStyle: {
    marginRight: "5px",
    fontSize: "22px"
  },
  listItemIcon: {
    marginRight: "0px"
  }
});

class TerminalSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      terminalOptions: this.props.terminalOptions,
      selectedTerminal: this.props.activeTerminal
    };
  }

  componentDidMount = () => {
    this.onTerminalCollapse(this.props.activeTerminal.terminalRegion);
  };

  setOpenRegions = (region, open = false) => {
    this.setState({ [region]: open });
  };

  onTerminalCollapse = region => {
    this.setState(state => ({ [region]: !state[region] }));
  };

  onSearchTextChanged = ({ target: { value } }) => {
    const searchText = value.toUpperCase();
    const openRegions = {};
    if (searchText) {
      const filteredTerminals = this.props.terminalOptions
        .map(terminals => {
          const filterData = {
            region: terminals.region,
            regionTerminals: terminals.regionTerminals.filter(terminalData =>
              terminalData.terminalCode.includes(searchText)
            )
          };

          if (filterData.regionTerminals.length) {
            return filterData;
          }
          return null;
        })
        .filter(result => result);

      filteredTerminals.map(group => {
        openRegions[group.region] = true;
      });

      this.setState({
        terminalOptions: filteredTerminals,
        ...openRegions
      });
    } else {
      this.props.terminalOptions.map(group => {
        group.region === this.props.activeTerminal.terminalRegion
          ? this.setOpenRegions(group.region, true)
          : this.setOpenRegions(group.region);
      });
      this.setState({
        terminalOptions: this.props.terminalOptions
      });
    }
  };

  changeTerminal = (terminal) => {
    this.props.handleTerminalChange(terminal);
    this.setState({
      selectedTerminal: terminal
    });
  };

  render() {
    const { classes, terminalAnchor, closeTerminalmenu } = this.props;
    const { terminalOptions } = this.state;
    return (
      <Menu
        disablePortal={false}
        getContentAnchorEl={null}
        disableAutoFocusItem={true}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={true}
        anchorEl={terminalAnchor}
        onClose={closeTerminalmenu}
        MenuListProps={{ disablePadding: true }}
        className={classes.terminalMenuRoot}
        classes={{
          paper: classes.terminalMenu
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <div align="center" className={classes.root}>
          <div className={classes.searchBar}>
            <TextField
              placeholder="Search"
              autoFocus
              className={classes.textField}
              onChange={this.onSearchTextChanged}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchOutlined />
                  </InputAdornment>
                ),
                className: classes.inputroot,
                disableUnderline: true
              }}
            />
          </div>
          <div className={classes.list}>
            <List
              component="div"
              className={`${classes.listroot} customScroll`}
            >
              {terminalOptions.length ? (
                terminalOptions.map((terminal, index) => (
                  <Fragment key={index}>
                    <ListItem
                      button
                      onClick={() => this.onTerminalCollapse(terminal.region)}
                      classes={{ root: classes.terminalClicked }}
                      disableGutters
                    >
                      <ListItemIcon className={classes.listItemIcon}>
                        {this.state[terminal.region] ? (
                          <ExpandMore
                            color="primary"
                            className={classes.collapseIconStyle}
                          />
                        ) : (
                          <ArrowRight
                            color="primary"
                            className={classes.collapseIconStyle}
                          />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        inset
                        primary={terminal.region}
                        classes={{
                          root: classes.disbalePadding,
                          primary: classes.label
                        }}
                      />
                    </ListItem>
                    <Collapse
                      in={this.state[terminal.region]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List
                        component="div"
                        className={classes.enablePadding}
                        disablePadding
                      >
                        {terminal.regionTerminals.map(terminalData => (
                          <ListItem
                            key={terminalData.terminalId}
                            classes={{ root: classes.terminalClicked }}
                            disableGutters
                          >
                            <RadioGroup
                              aria-label="Terminal"
                              name="terminal"
                              value={this.state.selectedTerminal?.terminalId.toString()}
                              onChange={() => this.changeTerminal(terminalData)}
                            >
                              <FormControlLabel
                                classes={{
                                  root: classes.radioLabel,
                                  label: classes.label
                                }}
                                value={terminalData.terminalId.toString()}
                                control={
                                  <Radio
                                    color="primary"
                                    classes={{ root: classes.radioRoot }}
                                  />
                                }
                                label={terminalData.terminalCode}
                              />
                            </RadioGroup>
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  </Fragment>
                ))
              ) : (
                <div className={classes.noOptions}>No Data Available</div>
              )}
            </List>
          </div>
        </div>
      </Menu>
    );
  }
}

export default withStyles(styles)(TerminalSelect);
